import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import './styles.scss'
import Heading from '../heading/Heading';
import Input from '../form/inputs/Input';
import InputPostal from '../form/inputs/InputPostal';
import Button from '../buttons/Button';
import Select from '../form/selects/Select';
import "moment/locale/pl";
import Moment from 'moment';
import banks from './../../static-data/banks.json';
import legalForms from './../../static-data/legal-forms.json';
import scrollPage from '../../services/scrollToErrors';
import Checkbox from '../form/checkbox/Checkbox';
import ButtonsNav from './../buttons-nav/ButtonsNav';

const FinancialInformation = ( props ) => {
    let [ load, setLoad ]                           = useState(false);
    let [ isOpen, setIsOpen ]                       = useState(false);
    let [ forceValidateNip, setForceValidateNip ]   = useState(false);
    let [ forceValidate, setForceValidate ]         = useState(false);
    let [ companyStartPicker, setCompanyStartPicker ] = useState(false);
    let [ dataFromGUS, setDataFromGUS ] = useState(false);

    const dispatch      = useDispatch()
    let trn             = useSelector(state => state.trn)
    let companyName     = useSelector(state => state.companyName)
    let companyAddress  = useSelector(state => state.companyAddress)
    let postalCustomer  = useSelector(state => state.postalCustomer)
    let city            = useSelector(state => state.city)
    let additionalCompanyAddress  = useSelector(state => state.additionalCompanyAddress)
    let additionalPostalCustomer  = useSelector(state => state.additionalPostalCustomer)
    let additionalCity            = useSelector(state => state.additionalCity)
    let phone           = useSelector(state => state.phone)
    let email           = useSelector(state => state.email)
    let emailFV         = useSelector(state => state.emailFV)
    let employeesNumber = useSelector(state => state.employeesNumber)
    let website         = useSelector(state => state.website)
    let additionalAddress       = useSelector(state => state.additionalAddress)
    let bank       = useSelector(state => state.bank)
    let bankAccountsNumbers     = useSelector(state => state.bankAccountsNumbers)
    let bankAccount             = useSelector(state => state.bankAccount)
    let otherBankAccountCheckbox = useSelector(state => state.otherBankAccountCheckbox)
    let otherBankAccount        = useSelector(state => state.otherBankAccount)
    let consentAutomaticBankAccountCheckbox = useSelector(state => state.consentAutomaticBankAccountCheckbox);
    let shareCapital                = useSelector(state => state.shareCapital);
    let legalForm                   = useSelector(state => state.legalForm);
    let lineBusiness                = useSelector(state => state.lineBusiness);
    let revenuePresentFinancialYear = useSelector(state => state.revenuePresentFinancialYear);
    let revenueLastFinancialYear    = useSelector(state => state.revenueLastFinancialYear);
    let financialCity               = useSelector(state => state.financialCity);
    let financialAddress            = useSelector(state => state.financialAddress);
    let bankCompanyName             = useSelector(state => state.bankCompanyName);
    let bankName                    = useSelector(state => state.bankName);
    let bankIban                    = useSelector(state => state.bankIban);
    let bankEmail                   = useSelector(state => state.bankEmail);

    let validateNIP = async () => {
        await setForceValidateNip(true);
        await wait(100);

        let result;
        let elements = document.querySelectorAll('.error-item-nip');
        if( elements.length > 0 ) {
            result = false;
            await setForceValidateNip(false);
        } else {
            result = true;
        }
        return result;
    }


    const getBankUrlRedirect = ( key ) => {
        if ( key.length == 0 ) {
            return false;
        }
        let getItem = banks.findIndex(x => x.name === key);

        let req = new XMLHttpRequest();
            req.open('GET', `https://newonline.leasingoptymalny.pl/API/linkVeryf.php?id=5c3fe4b4fce445d481e92a660953&bank=${ banks[getItem].key }`);
            req.send();

            req.addEventListener("readystatechange", function () {
                if (this.readyState === 4) {
                    let data = JSON.parse(req.response);
                    if(data && data.redirect_uri) {
                        dispatch({ type: 'BANK_URI_CHANGE', value: data.redirect_uri })
                    }
                }
            });
        
    }
    async function wait(ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms);
        });
    }
    
    let prev = () => {
        props.prev();
    }
    let next = async() => {
        await setForceValidate(true);
        await wait(500);
        let scroll = await scrollPage();
        if ( scroll ) {
            await setForceValidate(true);
        } else {
            await setForceValidate(false);
            await props.next();
        }
    }

    let changeAdditionalAddress = ( val ) => {
        dispatch({ type: 'ADDITIONAL_ADDRESS_CHANGE', value: val })

        if ( !val ) {
            dispatch({ type: 'ADDITIONAL_COMPANY_ADDRESS_CHANGE', value: '' })
            dispatch({ type: 'ADDITIONAL_POSTAL_CUSTOMER_CHANGE', value: '' })
            dispatch({ type: 'ADDITIONAL_CITY_CHANGE', value: '' })
        }
    }

    const getDataAndNext = async() => {
        await next();
    }

    return (
        <div className="financial-information">
            <div className="container">
                <Heading title="Financial Information" 
                    borderBottom
                    tip={ false } 
                    tipHeader="Liczba pracowników"
                    tipText="Wpisz łączną liczbę pracowników, niezależnie od formy zatrudnienia. W przypadku działalności jednoosobowej bez osób zatrudnionych, wpisz 0." />
                <Heading title="Company data" 
                    borderBottomDotted
                    medium
                    tip={ false } 
                    tipHeader="Company data"
                    tipText="Wpisz łączną liczbę pracowników, niezależnie od formy zatrudnienia. W przypadku działalności jednoosobowej bez osób zatrudnionych, wpisz 0." />
                <div className="input-row">
                    <div className="col">
                        <Input  name="trn"
                            id="trn"
                            required={ true }
                            setFunction={ val => { dispatch({ type: 'TRN_CHANGE', value: val }) } }
                            type="text"
                            label={ "TRN" }
                            placeholder={ "15-digit no." }
                            val={ trn }
                            size="full" 
                            errorClass="error-item-nip"
                            regExp={/^[0-9]{15}$/}
                            allowChars={/^[0-9]{0,15}$/}
                            minChar={ 15 } 
                            forceValidate={ forceValidateNip || forceValidate ? true : false } 
                            forceValidateItems={ forceValidate } />
                    </div>
                </div>

                <div className="input-row">
                    <div className="col">
                        <Input  name="share-capital"
                            id="share-capital"
                            required={ false }
                            setFunction={ val => dispatch({ type: 'SHARE_CAPITAL_CHANGE', value: val }) }
                            type="text"
                            label={ "Share capital (if applicable)" }
                            placeholder={ "Share capital (if applicable)" }
                            val={ shareCapital }
                            size="full" 
                            regExp={/^[0-9]*$/}
                            allowChars={/^[0-9]*$/}
                            minChar={ 1 } 
                            forceValidate={ forceValidate } />
                    </div>
                    <div className="col">
                        <Select
                            id="legal-form"
                            data={ legalForms }  
                            required={ true }
                            forceValidate={ forceValidate } 
                            val={ legalForm }
                            label="Legal form" 
                            setFunction={ (val) => dispatch({ type: 'LEGAL_FORM_CHANGE', value: val }) } />
                    </div>
                </div>

                <div className="input-row">
                    <div className="col">
                        <Input  name="line-of-business"
                                id="line-of-business"
                                required={ false }
                                setFunction={ val => dispatch({ type: 'LINE_BUSINESS_CHANGE', value: val }) }
                                type="text"
                                label={ "Line of business" }
                                placeholder={ "Line of business" }
                                val={ lineBusiness }
                                size="full" 
                                regExp={/.*/}
                                allowChars={/.*/}
                                minChar={ 1 } 
                                forceValidate={ forceValidate } />
                    </div>
                    <div className="col">
                        <Input  name="employees-number"
                                id="employees-number"
                                required={ true }
                                setFunction={ val => dispatch({ type: 'EMPLOYEES_NUMBER_CHANGE', value: val }) }
                                type="text"
                                label={ "Number of employees" }
                                placeholder={ "Number of employees" }
                                val={ employeesNumber }
                                size="full" 
                                regExp={/^[0-9]*$/}
                                allowChars={/^[0-9]*$/}
                                minChar={ 1 } 
                                forceValidate={ forceValidate } />
                    </div>
                </div>

                <div className="input-row">
                    <div className="col">
                        <Input  name="revenue-present"
                                id="revenue-present"
                                required={ true }
                                setFunction={ val => dispatch({ type: 'REVENUE_PRESENT_FINANCIAL_YEAR_CHANGE', value: val }) }
                                type="text"
                                label={ "Revenue present financial year (AED)" }
                                placeholder={ "Revenue present financial year" }
                                val={ revenuePresentFinancialYear }
                                size="full" 
                                regExp={/^[0-9]*$/}
                                allowChars={/^[0-9]*$/}
                                minChar={ 1 } 
                                forceValidate={ forceValidate } />
                    </div>
                    <div className="col">
                        <Input  name="revenue-last"
                                id="revenue-last"
                                required={ true }
                                setFunction={ val => dispatch({ type: 'REVENUE_LAST_FINANCIAL_YEAR_CHANGE', value: val }) }
                                type="text"
                                label={ "Revenue last financial year (AED)" }
                                placeholder={ "Revenue last financial year" }
                                val={ revenueLastFinancialYear }
                                size="full" 
                                regExp={/^[0-9]*$/}
                                allowChars={/^[0-9]*$/}
                                minChar={ 1 } 
                                forceValidate={ forceValidate } />
                    </div>
                </div>

                <Heading title="Full address of company from where operations are done if different from registered address" 
                    borderDotted
                    moreMarginTop
                    small />

                <div className="input-row">
                    <div className="col">
                        <Input  name="city"
                                id="city"
                                required={ true }
                                setFunction={ val => dispatch({ type: 'FINANCIAL_CITY_CHANGE', value: val }) }
                                type="text"
                                label={ "City / Place" }
                                placeholder={ "City / Place" }
                                val={ financialCity }
                                size="full" 
                                regExp={/.*/}
                                allowChars={/.*/}
                                minChar={ 1 } 
                                forceValidate={ forceValidate } />
                    </div>
                    <div className="col">
                        <Input  name="address-company"
                                id="address-company"
                                required={ true }
                                setFunction={ val => dispatch({ type: 'FINANCIAL_ADDRESS_CHANGE', value: val }) }
                                type="text"
                                label={ "Street and number" }
                                placeholder={ "Street and number" }
                                val={ financialAddress }
                                size="full" 
                                regExp={/.*/}
                                allowChars={/.*/}
                                minChar={ 1 } 
                                forceValidate={ forceValidate } />
                    </div>
                </div>

                <Heading title="Bank details" 
                    moreMarginTop
                    borderBottomDotted
                    medium
                    tip={ false } 
                    tipHeader="Company data"
                    tipText="Wpisz łączną liczbę pracowników, niezależnie od formy zatrudnienia. W przypadku działalności jednoosobowej bez osób zatrudnionych, wpisz 0." />

                <div className="input-row">
                    <div className="col">
                        <Input 
                            id="bank-company-name"
                            name={"bank-company-name"}
                            // required={(window.AppConfig && window.AppConfig.providerName.length > 0) || !isShop ? false : true}
                            required={true}
                            setFunction={ val => dispatch({ type: 'BANK_COMPANY_NAME_CHANGE', value: val }) }
                            type="text"
                            label={ "Company name as per registry with bank" }
                            placeholder="Company name"
                            val={ bankCompanyName } 
                            size="full" 
                            regExp={/.*/}
                            allowChars={/.*/}
                            minChar={ 1 } 
                            forceValidate={ props.forceValidate } />
                    </div>
                    <div className="col">
                        <Input 
                            id="bank-name"
                            name={"bank-name"}
                            // required={(window.AppConfig && window.AppConfig.providerName.length > 0) || !isShop ? false : true}
                            required={true}
                            setFunction={ val => dispatch({ type: 'BANK_NAME_CHANGE', value: val }) }
                            type="text"
                            label={ "Bank name" }
                            placeholder="Bank name"
                            val={ bankName } 
                            size="full" 
                            regExp={/.*/}
                            allowChars={/.*/}
                            minChar={ 1 } 
                            forceValidate={ props.forceValidate } />
                    </div>
                </div>

                <div className="input-row">
                    <div className="col">
                        <Input  name="bank-iban"
                                id="bank-iban"
                                required={ true }
                                setFunction={ val => dispatch({ type: 'BANK_IBAN_CHANGE', value: val }) }
                                type="text"
                                label={ "IBAN" }
                                placeholder={ "IBAN no." }
                                val={ bankIban }
                                size="full" 
                                regExp={/^[A-Za-z]{2}[0-9]{21}$/}
                                allowChars={/^[A-Za-z][A-Za-z0-9]*$/}
                                onClickIfEmptyPass={"AE"}
                                // regExp={/^[0-9]{23}$/}
                                // allowChars={/^[0-9]{0,23}$/}
                                minChar={ 23 } 
                                maxChar={ 23 }
                                forceValidate={ forceValidate } />
                    </div>
                    <div className="col">
                        <Input  name="bank-email"
                                id="bank-email"
                                required={ true }
                                setFunction={ val => dispatch({ type: 'BANK_EMAIL_CHANGE', value: val }) }
                                type="text"
                                label={ "Registered email address as per UAE Pass" }
                                placeholder={ "Registered email address" }
                                val={ bankEmail }
                                size="full" 
                                regExp={/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/}
                                allowChars={/.*/}
                                minChar={ 1 } 
                                forceValidate={ forceValidate } />
                    </div>
                </div>

                <ButtonsNav prev={() => prev()} next={() => getDataAndNext()} />
            </div>
        </div>
    )
}

export default FinancialInformation;